import React from 'react';
import {Modal, ModalHeader, ModalBody} from 'reactstrap';

const VerifyCodeModal = (props) => {
  const {openModal, modalTitle, className} = props;

  return (
    <>
      <Modal
        isOpen={openModal}
        className={className}
        centered={true}
        keyboard={false}
      >
        {modalTitle && <ModalHeader>{modalTitle}</ModalHeader>}
        <ModalBody>{props.children}</ModalBody>
      </Modal>
    </>
  );
};

export default VerifyCodeModal;
